import { useState, useEffect } from 'react'
import { useQuery } from '@apollo/react-hooks'
import { path } from 'ramda'
import AccountQuery from '../../graphql/queries/account.gql'

/**
 * Hook to return profiles
 */
export const useProfile = (fetchPolicy, options = {}) => {
  const [allProfiles, setAllProfiles] = useState([])
  const [currentProfile, setCurrentProfile] = useState({
    id: null,
    name: null,
    email: null
  })

  const { data, loading, error } = useQuery(AccountQuery, {
    fetchPolicy,
    ...options
  })

  useEffect(() => {
    if (options.skip) {
      setAllProfiles([])
      setCurrentProfile({ id: null, name: null, email: null })
      return
    }

    if (loading || error) return

    const profiles = path(['account', 'profiles'], data) ?? []
    const selectedProfile = path(['account', 'selectedProfile'], data)
    const profile = profiles.find(p => p.id === selectedProfile) ?? { id: null, name: null, email: null }

    setAllProfiles(profiles)
    setCurrentProfile(profile)
  }, [data, error, loading, options.skip])

  return {
    allProfiles,
    currentProfile,
    loading,
    error
  }
}
